import { combineReducers } from 'redux';

export const rootReducer = {};

export const baseReducer = combineReducers(rootReducer);

export type RootState = ReturnType<typeof baseReducer>;
